const state = {
  user: {},
  isLoggedIn: false
};

const getters = {
  user: state => state.user,
  isLoggedIn: state => state.isLoggedIn
};

const mutations = {
  logout(state) {
    state.user = {};
    state.isLoggedIn = false;
    localStorage.removeItem("token");
    localStorage.removeItem("expiresAt");
  },
  login(state, loginResponse) {
    state.user = loginResponse.admin;
    state.isLoggedIn = true;
    localStorage.setItem("token", loginResponse.token);
    localStorage.setItem("expiresAt", loginResponse.expiresAt);
  }
};

const actions = {
  logout({ commit }) {
    commit("logout");
  },
  login({ commit }, loginResponse) {
    commit("login", loginResponse);
  }
};

export default { state, getters, mutations, actions };
